// src/services/toast.js
//
// Bridge so plain-JS code (the Vuex store) can trigger the existing toast
// component. App.vue registers its showToast handler on mount; the store calls
// toastService.show(...). This reuses the single ToastContainer — no second
// notification system.
let handler = null;

export const toastService = {
  register(fn) {
    handler = fn;
  },
  show(payload) {
    if (handler) handler(payload);
  },
};
